

export default class Station {
    constructor (values = {}) {
        this.id = null
        this.author = null
        this.title = null
        this.is_stream = false
        this.image_url = ""
        Object.assign(this, values)
    }
}